module.exports = __webpack_public_path__ + "09_face.34c5f396.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer1/09_face.png
// module id = mjTC
// module chunks = 0